/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPaymentPersonalInformationFormOptions, FxIdDomainSettingsPaymentPersonalInformationFormOptionsFromJSONTyped, FxIdDomainSettingsPaymentPersonalInformationFormOptionsToJSON, } from './FxIdDomainSettingsPaymentPersonalInformationFormOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsPersonalInformationFormFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsPersonalInformationFormFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsPersonalInformationFormFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPaymentPersonalInformationFormOptions(json)) {
        return FxIdDomainSettingsPaymentPersonalInformationFormOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsPersonalInformationFormToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsPersonalInformationFormToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsPersonalInformationFormToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPaymentPersonalInformationFormOptions(value)) {
        return FxIdDomainSettingsPaymentPersonalInformationFormOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsPersonalInformationForm.js.map